<!--

Displayed at the top of department pages. Features the name of the department,
phone, and email. Can be styled any way you want.

Example (default) usage:

<page-heading
title="Jefferson County Clerk of Courts"
email="clerk@jeffersoncountyoh.com"
phone="(740) 283-8583"
></page-heading>

-->

<template>
  <div class="row text-primary">
    <div class="col-md-8 mt-5">
      <div class="title">
      {{title}}
      </div>

      <div class="phone">
        <template v-if="phone">
        <i class="material-icons">call</i>
        {{phone}}
        </template>
      </div>

      <div class="email ">
        <template v-if="email">
          <i class="material-icons">email</i>&nbsp;
          <a :href="`mailto:${this.email}`" class="text-primary">{{email}}</a>
        </template>
      </div>
    </div>

    <div class="row liner">
      <div class="col">
        <hr />  
      </div>
    </div>

  </div>
</template>

<script>

export default {
  components: {},
  data () {
    return {
      formattedEmail: ""
    }
  },
  props: ['title','phone','email'],
  created: function () {

  }
}
</script>

<style scoped>

.liner hr {
  margin-top: 2.0em;
  margin-bottom: 0;
  border-top: 3px solid #8db8d8;
}

.title {
  font-size: 2.0em;
  font-weight: bold;
  margin: 0;
  padding: 0;
  line-height: 1.25em;
}

.phone {
  font-size: 1.25em;
  margin: 1.0em 0 0 0;
}

.email {
  margin: 0.25em 0 0 0;
  font-weight: bold;
}

</style>
